(() => {
  if (window.__pdpSizeGuideLoaded) return;
  window.__pdpSizeGuideLoaded = true;

  const missingEvents = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const publish = (name, template) => {
    const productInfo = template.closest('product-info');
    document.dispatchEvent(new CustomEvent('pdp:size-guide', {
      detail: {
        name,
        sectionId: template.dataset.sectionId || productInfo?.dataset.section || '',
        productId: productInfo?.dataset.productId || '',
      },
    }));
  };

  const publishMissingOnce = (template) => {
    const key = `${template.dataset.sectionId || ''}:${template.closest('product-info')?.dataset.productId || ''}`;
    if (missingEvents.has(key)) return;
    missingEvents.add(key);
    publish('size_guide_target_missing', template);
  };

  const getTarget = () => {
    const target = document.getElementById('product-size-guide');
    const heading = target?.querySelector('#product-size-guide-title');
    return target && heading ? { target, heading } : null;
  };

  const openSizeGuide = (event, template, link) => {
    event.preventDefault();
    const destination = getTarget();
    if (!destination) {
      link.remove();
      publishMissingOnce(template);
      return;
    }

    const details = destination.target.closest('details');
    if (details && !details.open) details.open = true;

    window.requestAnimationFrame(() => {
      try {
        destination.heading.focus({ preventScroll: true });
      } catch (_error) {
        destination.heading.focus();
      }
      destination.target.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'start',
      });
      publish('size_guide_open', template);
    });
  };

  const hydrateTemplate = (template) => {
    if (!(template instanceof HTMLTemplateElement)) return;
    const existing = template.parentElement?.querySelector('[data-pdp-size-guide-link]');
    const destination = getTarget();

    if (!destination) {
      existing?.remove();
      publishMissingOnce(template);
      return;
    }
    if (existing) return;

    const link = template.content.querySelector('[data-pdp-size-guide-link]')?.cloneNode(true);
    if (!(link instanceof HTMLAnchorElement)) return;
    link.addEventListener('click', (event) => openSizeGuide(event, template, link));
    template.insertAdjacentElement('afterend', link);
  };

  const hydrate = () => {
    document.querySelectorAll('template[data-pdp-size-guide-link-template]').forEach(hydrateTemplate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
  } else {
    hydrate();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(hydrate, 0));
  }
  document.addEventListener('shopify:section:load', hydrate);
})();
